export default function CoachSchedule() {

  return (
    <div>
      this is coach logged in Schedule
    </div>
  )
}